(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedicineDialogController', MedicineDialogController);

    MedicineDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Medicine'];

    function MedicineDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Medicine) {
        var vm = this;
        vm.medicine = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:medicineUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.medicine.id !== null) {
                Medicine.update(vm.medicine, onSaveSuccess, onSaveError);
            } else {
                Medicine.save(vm.medicine, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
